<template>
  <div>
    <div
      class="component-wrapper suggested-routes secondary d-flex flex-column align-center pa-4"
    >
      <div
        :style="main"
        class="align-self-start d-flex flex-column align-start justify-center mb-4"
      >
        <div
          class="primary rounded-pill px-2 d-flex align-center return-button mr-4 mb-2"
          @click="
            step == 1
              ? $router.push(`/islands/area/${$route.params.area_id}`)
              : (step = 1)
          "
        >
          <v-btn icon>
            <v-icon color="white" size="17">mdi-arrow-left</v-icon>
          </v-btn>
          <span class="body-2 white--text pr-1">
            {{ step == 1 ? currentArea.name : $t("menu.areas") }}
          </span>
        </div>
      </div>

      <div
        v-if="loader && step == 1"
        class="d-flex flex-column align-center justify-center flex-grow-1"
        style="height: 500px"
      >
        <v-progress-circular indeterminate color="white" size="60">
        </v-progress-circular>
      </div>

      <div v-if="loader && step == 2" style="width: 80%">
        <v-skeleton-loader
          v-for="(n, i) in 3"
          :key="i"
          v-bind="attrs"
          type="image,paragraph"
          :loading="loader"
        ></v-skeleton-loader>
      </div>

      <div
        v-if="step == 1 && !loader"
        class="d-flex flex-column"
        style="width: 100%"
      >
        <div class="white--text body-1 text-h6 mb-2">
          {{ $t("pois.step2") }}
        </div>
        <div v-for="(subarea, i) in subareas" :key="i + subarea.id">
          <v-btn
            v-if="subarea.paths_count > 0 || subarea.id == 999"
            class="white--text align-self-start body-1 py-8 d-flex justify-start"
            text
            @click="onSubareaSelect(subarea)"
            style="text-transform: none"
            width="100%"
          >
            <span>
              {{ subarea.name }}
            </span>
          </v-btn>
          <v-divider v-if="subarea.paths_count > 0"></v-divider>
        </div>
      </div>

      <div
        v-else-if="step == 2 && !loader"
        v-for="(poi, i) in routes"
        :key="i"
        class="d-flex flex-column mb-4"
        style="width: 100%"
      >
        <div
          @click="$router.push(`${$route.path}/${poi.id}`)"
          class="d-flex justify-start align-center route font-weight-thin body-1 mb-2"
        >
          <v-card
            width="100%"
            height="auto"
            class="pa-4"
            style="border-radius: 15px"
          >
            <!-- <v-img
              width="100%"
              height="150px"
              v-if="poi.images.length != 0"
              :src="
                'https://api.e-naxios.com/images/' +
                poi.images[0].image[0].file_name
              "
            ></v-img>
            <div
              v-else
              style="width: 100%; height: 150px"
              class="d-flex align-center justify-center"
            >
              <v-icon size="100" color="secondary">
                mdi-image-off-outline
              </v-icon>
            </div> -->
            <div class="px-2 primary--text font-weight-bold">
              {{
                poi.name != null && poi.name.includes(":")
                  ? poi.name.split(":")[0]
                  : poi.name
              }}
              <br />
              <span class="secondary--text">
                {{
                  poi.name != null && poi.name.includes(":")
                    ? poi.name.split(":")[1]
                    : ""
                }}
              </span>
            </div>

            <!-- <div class="px-2 secondary--text text-caption"> -->
            <!-- {{ poiCategory(poi.category_id).name }} -->
            <!-- </div> -->
          </v-card>
        </div>
      </div>

      <div v-if="routes.length == 0 && step == 2" class="white--text">
        {{ $t("error_messages.no_paths") }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  async created() {
    try {
      const subareas = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/subareas`
      );

      this.subareas = subareas.data;
      this.subareas.push({
        name: this.$t("general.all"),
        id: 999,
      });
      // const res = await axios.get(
      //   `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/paths`
      // );
      // this.routes = res.data.paths;
      this.loader = false;
    } catch (e) {
      throw e;
    }
  },

  data() {
    return {
      subareas: [],
      loader: true,
      routes: [],
      step: 1,
    };
  },

  computed: {
    ...mapState({
      currentArea: (state) => state.areas.currentArea,
      insets: (state) => state.base.insets,
    }),

    main() {
      return {
        margin: `${this.insets?.top}px 0px 0px 0px`,
      };
    },
  },

  methods: {
    async onSubareaSelect(subarea) {
      this.loader = true;
      if (subarea.id == 999) {
        const routes = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/subarea/paths`
        );
        this.step = 2;

        this.routes = routes.data;
        this.subarea = subarea;
        this.loader = false;

        return;
      }

      const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/paths`, {
        params: {
          area: subarea.id,
        },
      });
      this.routes = res.data;
      this.step = 2;
      this.subarea = subarea;
      this.loader = false;
    },
  },
};
</script>

<style scoped lang="scss">
.suggested-routes {
  top: 0px;
  height: 50vh;
  width: 100vw;
  position: absolute;
  // flex: 1 1 1px; /* new */
  overflow-y: auto !important;
  height: 100%;
}

.route {
  width: 100%;
}
</style>